const ContactInfo = {
    contact_phone: "+966532900988",
    contact_phone2: "+966500519974",
    contact_email: "info@q-techksa.com",
    hr_email: "hr@q-techksa.com",
    address: "7783 King Khalid Rd, Al Buhairah, Al Khobar 34722, Saudi Arabia",
    office_address_line1: "7783 King Khalid Rd, Al Buhairah",
    office_address_line2: "Al Khobar 34722, Eastern Province, Saudi Arabia",
    office_map_query: "MS PLAZA, 7783 King Khalid Rd, Al Buhairah, Al Khobar 34722, Saudi Arabia",
    office_maps_share_url:
        "http://google.com/maps/place/MS+PLAZA+%D9%85%D9%83%D8%A7%D8%AA%D8%A8+%D9%84%D9%84%D8%A5%D9%8A%D8%AC%D8%A7%D8%B1%E2%80%AD/@26.2381661,50.1578578,13z/data=!4m10!1m2!2m1!1sms+plaza+al+khobar!3m6!1s0x3e49c3aea2adf115:0xf35f2c9363f532dd!8m2!3d26.1901017!4d50.1876654!15sChJtcyBwbGF6YSBhbCBraG9iYXKSAQ9zaG9wcGluZ19jZW50ZXLgAQA!16s%2Fg%2F11fntbmh40!5m1!1e1?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D",
    office_map_embed_url: "",
    office_map_lat: 26.1901017,
    office_map_lng: 50.1876654,
    office_map_zoom: 17,
    facebook:"https://www.facebook.com/profile.php?id=61586997719438",
    X: "https://x.com/t61337_quality?s=20",
    instagram: "https://www.instagram.com/technologiesquality?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
    tiktok: "https://www.tiktok.com/@qualitytechnologies?is_from_webapp=1&sender_device=pc",
    snapchat: "https://www.snapchat.com/@quality7946?sender_web_id=13de1da4-e2be-4f5a-9896-24be8a98827e&device_type=desktop&is_copy_url=true",
}


export { ContactInfo }
